import "@/lib/sentry";
import "@/db/prewarm"; // Start worker + WASM before React mounts

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "@/app";
import { initAnalytics } from "@/lib/analytics";
import { registerServiceWorker } from "@/pwa";

import "@hicya/ui/fonts";
import "@/styles/global.scss";

initAnalytics();

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

registerServiceWorker();
